(function () {
  var self = document.getElementById("solution-custom-cookie");
  var blockedDomains = self.dataset.blockedDomains;

  if(blockedDomains !== undefined || blockedDomains !== "") {
    blockedDomains = blockedDomains.split(";");
  } else {
    blockedDomains = [];
  }

  window.Shopify.loadFeatures(
    [
      {
        name: "consent-tracking-api",
        version: "0.1",
      },
    ],
    (error) => {
      if (error) {
        console.error("custom cookie error occured:\n", error);

        return;
      }

      var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      var hasMarketingConsent = consent && consent.marketing === "yes";

      if (!hasMarketingConsent) {
        var originalCreateElement = document.createElement;
        var originalAppendChild = Element.prototype.appendChild;
        var originalInsertBefore = Element.prototype.insertBefore;

        document.createElement = function (tagName) {
          var element = originalCreateElement.call(document, tagName);
          if (tagName.toLowerCase() === "script") {
            Object.defineProperty(element, "src", {
              get: function () {
                return this.getAttribute("src");
              },
              set: function (value) {
                if (shouldBlockScript(value)) {
                  console.debug("blocking script:", value);

                  return;
                }
                this.setAttribute("src", value);
              },
            });
          }
          return element;
        };

        Element.prototype.appendChild = function (element) {
          if (element.tagName === "SCRIPT") {
            var src = element.src || "";
            if (shouldBlockScript(src)) {
              console.debug("blocking script via appendChild:", src);
              return element;
            }
          }
          return originalAppendChild.call(this, element);
        };

        Element.prototype.insertBefore = function (newNode, referenceNode) {
          if (newNode.tagName === "SCRIPT") {
            var src = newNode.src || "";
            if (shouldBlockScript(src)) {
              console.debug("blocking script via insertBefore:", src);
              return newNode;
            }
          }
          return originalInsertBefore.call(this, newNode, referenceNode);
        };

        var scripts = document.getElementsByTagName("script");
        for (var i = scripts.length - 1; i >= 0; i--) {
          var script = scripts[i];
          var src = script.src || "";
          if (shouldBlockScript(src)) {
            console.debug("removing existing script:", src);
            script.parentNode.removeChild(script);
          }
        }

        var iframes = document.getElementsByTagName("iframe");
        for (var i = iframes.length - 1; i >= 0; i--) {
          var iframe = iframes[i];
          var src = iframe.src || "";
          if (shouldBlockScript(src)) {
            console.debug("removing existing iframe:", src);
            iframe.parentNode.removeChild(iframe);
          }
        }
        
        if (window.fetch) {
          var originalFetch = window.fetch;
          window.fetch = function (...args) {
            var url = args[0];

            var requestURL = url;

            if(url !== null && typeof url === "object") {
              if(url.url) {
                requestURL = url.url;
              }

              if(url.href) {
                requestURL = url.href;
              }
            }
            
            if (shouldBlockScript(requestURL)) {
              console.debug("Blocking fetch request to:", requestURL);
              return Promise.resolve(
                new Response(null, { status: 204, statusText: "No Content" })
              );
            }
            return originalFetch.apply(this, args);
          };
        }

        if (window.XMLHttpRequest) {
          var OriginalXMLHttpRequest = window.XMLHttpRequest;
          window.XMLHttpRequest = function () {
            var xhr = new OriginalXMLHttpRequest();
            var originalOpen = xhr.open;

            xhr.open = function (method, url, async, user, password) {
              xhr._url = url;
              return originalOpen.apply(this, arguments);
            };

            var originalSend = xhr.send;
            xhr.send = function () {
              var url = xhr._url;

              if (shouldBlockScript(url)) {
                console.debug("blocking XMLHttpRequest to:", url);
                xhr.abort();
                return;
              }
              return originalSend.apply(this, arguments);
            };
            return xhr;
          };
        }

        var OriginalImage = window.Image;
        window.Image = function (width, height) {
          var img = new OriginalImage(width, height);
          Object.defineProperty(img, "src", {
            set: function (url) {
              if (shouldBlockScript(url)) {
                console.debug("blocking image request to:", url);
                return;
              }
              img.setAttribute("src", url);
            },
            get: function () {
              return img.getAttribute("src");
            },
          });
          return img;
        };
      }

      function shouldBlockScript(src) {
        return blockedDomains.some(function (domain) {
          let compliment = false;

          try {
            if ("TrustedScriptURL" in window && src instanceof TrustedScriptURL) {
              compliment = src.toString().includes(domain);
            } else {
              compliment = src.includes(domain);
            }
          } catch(err) {
            console.error("Failed to verify if url is blocked.", err);
          } finally {
            return compliment;
          }
        });
      }
    }
  );
})();
